/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';

import { ClientCareSurveySelectionProcessModel } from '../models/client-care-survey-selection-process-model';
import { ClientRepStatusModel } from '../models/client-rep-status-model';
import { getClientSurveysReport$Json } from '../fn/report/get-client-surveys-report-json';
import { GetClientSurveysReport$Json$Params } from '../fn/report/get-client-surveys-report-json';
import { getClientSurveysReport$Plain } from '../fn/report/get-client-surveys-report-plain';
import { GetClientSurveysReport$Plain$Params } from '../fn/report/get-client-surveys-report-plain';
import { getStatusByRepReport$Json } from '../fn/report/get-status-by-rep-report-json';
import { GetStatusByRepReport$Json$Params } from '../fn/report/get-status-by-rep-report-json';
import { getStatusByRepReport$Plain } from '../fn/report/get-status-by-rep-report-plain';
import { GetStatusByRepReport$Plain$Params } from '../fn/report/get-status-by-rep-report-plain';
import { getSurveysNeedingApprovalReport$Json } from '../fn/report/get-surveys-needing-approval-report-json';
import { GetSurveysNeedingApprovalReport$Json$Params } from '../fn/report/get-surveys-needing-approval-report-json';
import { getSurveysNeedingApprovalReport$Plain } from '../fn/report/get-surveys-needing-approval-report-plain';
import { GetSurveysNeedingApprovalReport$Plain$Params } from '../fn/report/get-surveys-needing-approval-report-plain';
import { SurveyNeedingApprovalModel } from '../models/survey-needing-approval-model';

@Injectable({ providedIn: 'root' })
export class ReportService extends BaseService {
  constructor(config: ApiConfiguration, http: HttpClient) {
    super(config, http);
  }

  /** Path part for operation `getClientSurveysReport()` */
  static readonly GetClientSurveysReportPath = '/api/Report/ClientsToContact';

  /**
   * get the report of clients to contact for surveys.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getClientSurveysReport$Plain()` instead.
   *
   * This method doesn't expect any request body.
   */
  getClientSurveysReport$Plain$Response(params: GetClientSurveysReport$Plain$Params, context?: HttpContext): Observable<StrictHttpResponse<ClientCareSurveySelectionProcessModel>> {
    return getClientSurveysReport$Plain(this.http, this.rootUrl, params, context);
  }

  /**
   * get the report of clients to contact for surveys.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `getClientSurveysReport$Plain$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getClientSurveysReport$Plain(params: GetClientSurveysReport$Plain$Params, context?: HttpContext): Observable<ClientCareSurveySelectionProcessModel> {
    return this.getClientSurveysReport$Plain$Response(params, context).pipe(
      map((r: StrictHttpResponse<ClientCareSurveySelectionProcessModel>): ClientCareSurveySelectionProcessModel => r.body)
    );
  }

  /**
   * get the report of clients to contact for surveys.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getClientSurveysReport$Json()` instead.
   *
   * This method doesn't expect any request body.
   */
  getClientSurveysReport$Json$Response(params: GetClientSurveysReport$Json$Params, context?: HttpContext): Observable<StrictHttpResponse<ClientCareSurveySelectionProcessModel>> {
    return getClientSurveysReport$Json(this.http, this.rootUrl, params, context);
  }

  /**
   * get the report of clients to contact for surveys.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `getClientSurveysReport$Json$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getClientSurveysReport$Json(params: GetClientSurveysReport$Json$Params, context?: HttpContext): Observable<ClientCareSurveySelectionProcessModel> {
    return this.getClientSurveysReport$Json$Response(params, context).pipe(
      map((r: StrictHttpResponse<ClientCareSurveySelectionProcessModel>): ClientCareSurveySelectionProcessModel => r.body)
    );
  }

  /** Path part for operation `getStatusByRepReport()` */
  static readonly GetStatusByRepReportPath = '/api/Report/StatusByRep';

  /**
   * get the report of statuses by rep.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getStatusByRepReport$Plain()` instead.
   *
   * This method doesn't expect any request body.
   */
  getStatusByRepReport$Plain$Response(params: GetStatusByRepReport$Plain$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<ClientRepStatusModel>>> {
    return getStatusByRepReport$Plain(this.http, this.rootUrl, params, context);
  }

  /**
   * get the report of statuses by rep.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `getStatusByRepReport$Plain$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getStatusByRepReport$Plain(params: GetStatusByRepReport$Plain$Params, context?: HttpContext): Observable<Array<ClientRepStatusModel>> {
    return this.getStatusByRepReport$Plain$Response(params, context).pipe(
      map((r: StrictHttpResponse<Array<ClientRepStatusModel>>): Array<ClientRepStatusModel> => r.body)
    );
  }

  /**
   * get the report of statuses by rep.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getStatusByRepReport$Json()` instead.
   *
   * This method doesn't expect any request body.
   */
  getStatusByRepReport$Json$Response(params: GetStatusByRepReport$Json$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<ClientRepStatusModel>>> {
    return getStatusByRepReport$Json(this.http, this.rootUrl, params, context);
  }

  /**
   * get the report of statuses by rep.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `getStatusByRepReport$Json$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getStatusByRepReport$Json(params: GetStatusByRepReport$Json$Params, context?: HttpContext): Observable<Array<ClientRepStatusModel>> {
    return this.getStatusByRepReport$Json$Response(params, context).pipe(
      map((r: StrictHttpResponse<Array<ClientRepStatusModel>>): Array<ClientRepStatusModel> => r.body)
    );
  }

  /** Path part for operation `getSurveysNeedingApprovalReport()` */
  static readonly GetSurveysNeedingApprovalReportPath = '/api/Report/SurveysNeedingApproval';

  /**
   * get the report for surveys needing approval.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getSurveysNeedingApprovalReport$Plain()` instead.
   *
   * This method doesn't expect any request body.
   */
  getSurveysNeedingApprovalReport$Plain$Response(params?: GetSurveysNeedingApprovalReport$Plain$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<SurveyNeedingApprovalModel>>> {
    return getSurveysNeedingApprovalReport$Plain(this.http, this.rootUrl, params, context);
  }

  /**
   * get the report for surveys needing approval.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `getSurveysNeedingApprovalReport$Plain$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getSurveysNeedingApprovalReport$Plain(params?: GetSurveysNeedingApprovalReport$Plain$Params, context?: HttpContext): Observable<Array<SurveyNeedingApprovalModel>> {
    return this.getSurveysNeedingApprovalReport$Plain$Response(params, context).pipe(
      map((r: StrictHttpResponse<Array<SurveyNeedingApprovalModel>>): Array<SurveyNeedingApprovalModel> => r.body)
    );
  }

  /**
   * get the report for surveys needing approval.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getSurveysNeedingApprovalReport$Json()` instead.
   *
   * This method doesn't expect any request body.
   */
  getSurveysNeedingApprovalReport$Json$Response(params?: GetSurveysNeedingApprovalReport$Json$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<SurveyNeedingApprovalModel>>> {
    return getSurveysNeedingApprovalReport$Json(this.http, this.rootUrl, params, context);
  }

  /**
   * get the report for surveys needing approval.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `getSurveysNeedingApprovalReport$Json$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getSurveysNeedingApprovalReport$Json(params?: GetSurveysNeedingApprovalReport$Json$Params, context?: HttpContext): Observable<Array<SurveyNeedingApprovalModel>> {
    return this.getSurveysNeedingApprovalReport$Json$Response(params, context).pipe(
      map((r: StrictHttpResponse<Array<SurveyNeedingApprovalModel>>): Array<SurveyNeedingApprovalModel> => r.body)
    );
  }

}
